module.exports = __webpack_public_path__ + "assets/e9802d82dc5b6227abf11fb64ed11779.png";